/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Carousel } from "react-bootstrap";
import { useState, useEffect } from "react";
import { fetchDocumentList } from "../../Api/apiService";

const CarouselCard = ({ slides }) => {
  const [backendDocs, setBackendDocs] = useState([]);
  const request = {
    page_no: 1,
    limit: 100,
    doc_type: "backend_banner",
    type: "web",
  };
  useEffect(() => {
    fetchDocumentList({ request }).then((data) => {
      setBackendDocs(data?.data?.data || []);
    });
  }, []);
  const slideData2 = backendDocs?.map((doc) => {
    return {
      image: doc?.web_file_url,
      heading: doc?.title,
      caption: doc?.sub_title,
    };
  });

  return (
    <Card
      style={{
        height: "90vh",
        backgroundColor: "#FFFFFF",
        borderRadius: "21px",
        border: "none",
      }}
      className="my-4"
    >
      <Card.Body>
        <Carousel data-bs-theme="dark">
          {slideData2?.map((slide, index) => (
            <Carousel.Item key={index}>
              <div
                className="text-center mx-auto"
                style={{ height: "298px", width: "270px" }}
              >
                <img
                  className="d-block w-75 mx-auto"
                  src={slide?.image}
                  alt={`Slide ${index + 1}`}
                  style={{ objectFit: "cover" }}
                />
              </div>
              <div className="mt-5 text-center">
                <h5 className="login-carousel-heading">{slide?.heading}</h5>
                <p className="login-carousel-caption">{slide?.caption}</p>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </Card.Body>
    </Card>
  );
};

export default CarouselCard;
